import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { sessionLogger } from '@chegg-ui/utils';
import { SecondaryLink } from '@chegg-ui/link';
import { getAboutLinks, getLegalLinks, getNetworkLinks, getProductLinks, getServiceLinks } from '../shared';
import { StyledAccordion, AccordionHeader, MobileFooterLinkTitle, MobileFooterLinkList, MobileFooterLinkListItem } from '../styles';

var getFooterSections = function getFooterSections(envUrl) {
  return [{
    title: 'COMPANY',
    links: getAboutLinks(envUrl)
  }, {
    title: 'LEGAL & POLICIES',
    links: getLegalLinks(envUrl)
  }, {
    title: 'CHEGG PRODUCTS AND SERVICES',
    links: getProductLinks(envUrl)
  }, {
    title: 'CHEGG NETWORK',
    links: getNetworkLinks()
  }, {
    title: 'CUSTOMER SERVICE',
    links: getServiceLinks(envUrl)
  }];
};

var MobileFooterLinks = function MobileFooterLinks(_ref) {
  var envUrl = _ref.envUrl,
      pageTrackId = _ref.pageTrackId;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      activeFooterIndex = _useState2[0],
      setActiveFooterIndex = _useState2[1];

  return /*#__PURE__*/React.createElement(StyledAccordion, {
    activeTabIndex: activeFooterIndex,
    id: "footer-links-accordion",
    onChangeIndex: setActiveFooterIndex // TODO infra: memo? https://chegg.atlassian.net/browse/CUI-368
    ,
    tabs: getFooterSections(envUrl).map(function (footerSection) {
      return {
        header: /*#__PURE__*/React.createElement(AccordionHeader, null, /*#__PURE__*/React.createElement(MobileFooterLinkTitle, null, footerSection.title)),
        panel: /*#__PURE__*/React.createElement(MobileFooterLinkList, null, footerSection.links.map(function (linkDetails) {
          return /*#__PURE__*/React.createElement(MobileFooterLinkListItem, {
            key: linkDetails.href
          }, /*#__PURE__*/React.createElement(SecondaryLink, {
            className: linkDetails.className,
            id: linkDetails.id,
            href: linkDetails.href,
            rel: linkDetails.nofollow ? 'nofollow' : undefined,
            "data-test": "footer-".concat(linkDetails.loggingKey),
            onClick: function onClick() {
              sessionLogger.event(envUrl, pageTrackId, {
                footer_cta_click: linkDetails.loggingKey
              });
            }
          }, linkDetails.text));
        }))
      };
    })
  });
};

MobileFooterLinks.displayName = 'MobileFooterLinks';
export default MobileFooterLinks;